import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import Dentin from '@/pages/getRecipe/PfmCrown/dentin'
import Enamel from '@/pages/getRecipe/PfmCrown/enamel'
import InternalEffects from '@/pages/getRecipe/PfmCrown/internalEffects'
import Opaquer from '@/pages/getRecipe/PfmCrown/opaquer'
import OpaquerStaining from '@/pages/getRecipe/PfmCrown/opaquerStaining'
import StainingCorrections from '@/pages/getRecipe/PfmCrown/stainingCorrection'

import LoadingSpinner from '../components/LoadingSpinner'

const PfmCrownRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="crown" element={<StainingCorrections />} />
        <Route path="opaquer" element={<Opaquer />} />
        <Route path="opaquer-staining" element={<OpaquerStaining />} />
        <Route path="dentin" element={<Dentin />} />
        <Route path="internal-effects" element={<InternalEffects />} />
        <Route path="staining-corrections" element={<StainingCorrections />} />
        <Route path="enamel" element={<Enamel />} />
        <Route path="" element={<Navigate to="crown" replace={true} />} />
      </Routes>
    </Suspense>
  )
}

export default PfmCrownRoutes
